export enum ExecutionEnvironment {
    Browser = 'browser',
    DAWPlugin = 'daw-plugin',
}
